/* eslint-disable */

(function ($) {
    $.widget('ep.date_record_input_field', $.ep.base_record_field, {
        options:
            {
                templateId: 'edit-record-date-field',

                // ui options
                ui: {
                    datepickerButtonImage: ""
                },
                resources: {
                    buttonText: ""
                }
            },

        getData: function () {
            var input = $(".text_date_box", this.element);

            if (input.val().length > 0) {
                var date = input.forms_datepicker("getDate");
                this._model.Value = $.datepicker.formatDate('dd.mm.yy', date);
            } else {
                this._model.Value = null;
            }

            return this._model;
        },

        afterRenderTemplate: function () {
            var datePickerInput = $(".text_date_box", this.element);

            datePickerInput.forms_datepicker({
                buttonText: this.options.resources.buttonText,
                showOn: "button",
                buttonImage: this.options.ui.datepickerButtonImage,
                buttonImageOnly: true,
                resources: this.options.resources,
                culture: this.options.culture,
                minDate: new Date(1900, 0, 1)
            });

            if (this._model.Value != undefined) {
                var date = $.datepicker.parseDate('dd.mm.yy', this._model.Value);

                datePickerInput.datepicker('setDate', date);
            }

            this.setValidationRules();
        },

        setDisabled: function () {
            $('.field-container input', this.element).prop('disabled', true);
            $(".text_date_box", this.element).datepicker('disable');
        },

        setValidationRules: function () {

            $(".text_date_box", this.element).rules("add",
                        {
                            required: this.options.model.Required,
                            jQueryMinMaxDates: true,
                            messages: {
                                required: this.options.resources.validationRequired,
                                jQueryMinMaxDates:
                                    this.options.resources.invalidDate != undefined
                                    ? this.options.resources.invalidDate.replace('{0}', ep.currentCultureSettings.datePlaceholder)
                                    : 'Date is invalid.'
                            }
                        });
        },

        destroy: function () {
            $(".text_date_box", this.element).forms_datepicker('destroy');

            // Call the base destroy function
            $.Widget.prototype.destroy.call(this);
        }
    });
})(jQuery);

/* eslint-enable */